import { Components, Theme } from '@mui/material';

export const MuiCard: Components<Theme>['MuiCard'] = {
  defaultProps: {
    variant: 'outlined',
  },
};
